// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"38":"8709def6","488":"234819af","594":"0121db15"}[chunkId] + ".chunk.css";
};